module.exports = __webpack_public_path__ + "media/images/official/voice_akamatsu-3c96e37e320d756cb004e188a634a0e4.png";